import { Card, Text, makeStyles, tokens } from '@fluentui/react-components';
import type { MenuItem } from '../types/catering';
import placeholderImage from '../mocks/assets/menu/executive-breakfast.png';
import { DietaryDots } from './DietaryDots';

const useStyles = makeStyles({
  row: {
    display: 'grid',
    gridTemplateColumns: '3rem 1fr',
    gap: tokens.spacingHorizontalM,
    padding: tokens.spacingVerticalS,
    borderRadius: '0',
    boxShadow: 'none',
    borderLeft: '0',
    borderRight: '0',
  },
  image: {
    width: '3rem',
    height: '3rem',
    objectFit: 'cover',
    borderRadius: tokens.borderRadiusMedium,
  },
  copy: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    minWidth: '0',
  },
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  metadata: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalS,
  },
  quantity: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: `0 ${tokens.spacingHorizontalS}`,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
  },
});

export type OrderLineRowProps = {
  item: MenuItem;
  portionsPerPerson: number;
  headcount: number;
};

export function OrderLineRow({ item, portionsPerPerson, headcount }: OrderLineRowProps) {
  const styles = useStyles();
  return (
    <Card className={styles.row}>
      <img className={styles.image} src={item.imageUrl ?? placeholderImage} alt="" />
      <div className={styles.copy}>
        <Text className={styles.title} weight="semibold">
          {item.name}
        </Text>
        <div className={styles.metadata}>
          <span className={styles.quantity}>Qty: {portionsPerPerson * headcount}</span>
          <DietaryDots allergens={item.allergens} />
        </div>
      </div>
    </Card>
  );
}
